const WarningIcon = ({ className = "w-6 h-6" }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99996 18.3327C14.5833 18.3327 18.3333 14.5827 18.3333 9.99935C18.3333 5.41602 14.5833 1.66602 9.99996 1.66602C5.41663 1.66602 1.66663 5.41602 1.66663 9.99935C1.66663 14.5827 5.41663 18.3327 9.99996 18.3327Z" stroke="#6B635D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 6.66602V10.8327" stroke="#6B635D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.99536 13.334H10.0028" stroke="#6B635D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);

export default WarningIcon;
